import React from "react";
import colors from "assets/theme-dark/base/colors";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
export default function SpinLoader() {
  const { singh } = colors;
  return (
    <MDBox color={singh.main}>
      <CircularProgress size={30} color="inherit" />
    </MDBox>
  );
}
